// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BARx","inner":"styles_inner__2ONyV","right":"styles_right__F4Vur","close":"styles_close__u_IoG","footer":"styles_footer__1b7YA"};